import { render, staticRenderFns } from "./LPHeaderMenuPc.vue?vue&type=template&id=2d3ec826&scoped=true"
import script from "./LPHeaderMenuPc.vue?vue&type=script&setup=true&lang=ts"
export * from "./LPHeaderMenuPc.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LPHeaderMenuPc.vue?vue&type=style&index=0&id=2d3ec826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3ec826",
  null
  
)

export default component.exports